export default __webpack_public_path__ + "193064bc31bd22e87c27c4d4f0145893.png";